import { useNavigate } from 'react-router-dom';
import { pageInfo } from '../../constants/pageInfo/pageInfo.constant';
import { browserStorage } from '../../utils/browserStorage.util';

interface IUseRedirectToStoredPageReturn {
  navigateToStoredPage: () => void;
}

export const useRedirectToStoredPage = (): IUseRedirectToStoredPageReturn => {
  const navigate = useNavigate();

  const navigateToStoredPage = () => {
    const storedPagePath = browserStorage.getItem({
      storageType: 'sessionStorage',
      itemKey: 'storedPageForRedirection',
    });

    if (!storedPagePath) {
      navigate(pageInfo.home.path, { replace: true });
      return;
    }

    navigate(storedPagePath, { replace: true });
  };

  return { navigateToStoredPage };
};
